(function() {
  var BaseHandler, BaseOutput, DetailOutput,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseHandler = App.loadClass('core::reports/BaseHandler');

  DetailOutput = App.loadClass('core::reports/DetailOutput');

  BaseOutput = App.loadClass('core::reports/BaseOutput');

  exports.Reports_Fertilizer_SubHandler = (function(superClass) {
    extend(Reports_Fertilizer_SubHandler, superClass);

    function Reports_Fertilizer_SubHandler() {
      return Reports_Fertilizer_SubHandler.__super__.constructor.apply(this, arguments);
    }

    Reports_Fertilizer_SubHandler.prototype.init = function() {
      this.hasPrint = true;
      this.excelUrl = 'backend/grower/reports/fertilizer/excel';
      this.filterUrl = 'backend/grower/reports/fertilizer/filters';
      this.layoutSelector = '#reports_fertilizer_tab';
      this.parent.dialog.find('.excel-btn').removeClass('hidden');
      return this.initFilters();
    };

    Reports_Fertilizer_SubHandler.prototype.initFilters = function() {
      this.resetFilters();
      this.parent.filters.importGroup({
        name: 'Fertilizer Filters',
        filters: [
          {
            name: 'timings',
            display_name: 'Timing'
          }, {
            name: 'sources',
            display_name: 'Source'
          }, {
            name: 'application_date',
            display_name: 'Application Date',
            control_type: 'daterangepicker',
            listenForYear: function(years) {
              var drp, max, min;
              years = years.map(function(val) {
                return val.key;
              });
              drp = $(this.ele).data('daterangepicker');
              min = _.min(years);
              max = _.max(years);
              if (!min && !max) {
                return $(this.ele).prop('disabled', true);
              } else {
                $(this.ele).prop('disabled', false);
                if (drp != null) {
                  drp.minDate = moment((min - 1).toString().concat('-1-1'), 'YYYY-MM-DD');
                }
                return drp != null ? drp.maxDate = moment((max + 1).toString().concat('-12-31'), 'YYYY-MM-DD') : void 0;
              }
            }
          }, {
            name: 'status',
            display_name: 'Status',
            control_type: 'option',
            deletable: false,
            values: [
              {
                key: 'planned',
                value: 'Plan'
              }, {
                key: 'actual',
                value: 'Record'
              }
            ],
            selected_values: [
              {
                key: 'actual',
                value: 'Record'
              }
            ]
          }, {
            name: 'output_type',
            display_name: 'Output Type',
            control_type: 'option',
            deletable: false,
            values: [
              {
                key: 'detail',
                value: 'Detail'
              }, {
                key: 'summary',
                value: 'Summary'
              }
            ],
            selected_values: [
              {
                key: 'detail',
                value: 'Detail'
              }
            ]
          }
        ]
      });
      return this.setDefaultsAndRun();
    };

    Reports_Fertilizer_SubHandler.prototype.destroy = function() {
      this.parent.filters.removeGroup("Fertilizer Filters");
      this.parent.dialog.find('.excel-btn').addClass('hidden');
      return Reports_Fertilizer_SubHandler.__super__.destroy.call(this);
    };

    Reports_Fertilizer_SubHandler.prototype.beforeApply = function() {
      var filters;
      filters = this.parent.filters.jsonize();
      if (filters.filters.output_type[0].key === 'detail') {
        this.printUrl = 'backend/grower/reports/fertilizer/print/detail';
        this.layoutUrl = 'backend/grower/reports/fertilizer/table/detail';
        return this.currentOutput = new DetailOutput(this, this.parent, 'auto', {
          sAjaxSource: 'backend/grower/reports/fertilizer/output/detail'
        });
      } else {
        this.printUrl = 'backend/grower/reports/fertilizer/print/summary';
        this.layoutUrl = 'backend/grower/reports/fertilizer/output/summary';
        return this.currentOutput = new BaseOutput(this, this.parent, 'auto');
      }
    };

    return Reports_Fertilizer_SubHandler;

  })(BaseHandler);

}).call(this);
